export const LocationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
        <path
            fill="#8C8C8C"
            d="M12.75 7.5A3.749 3.749 0 0 0 9 3.75 3.749 3.749 0 0 0 5.25 7.5c0 .473.213 1.14.621 1.938.396.778.935 1.599 1.486 2.356.548.754 1.1 1.43 1.512 1.92l.131.154.131-.155a32.77 32.77 0 0 0 1.512-1.92c.55-.756 1.087-1.577 1.486-2.355.408-.799.621-1.465.621-1.938Zm.75 0c0 2.081-2.829 5.576-4 6.935-.308.356-.5.565-.5.565s-.192-.209-.5-.565c-1.171-1.36-4-4.854-4-6.935a4.501 4.501 0 0 1 9 0Zm-5.625 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0ZM9 9.375a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z"
        />
    </svg>
);
